export const responseBlobFile = async (response: any) => {
    const file = new Blob([response?.data], { type: 'application/octet-stream' });
    const contentDisposition = response?.headers.get('Content-Disposition');
    const filename = contentDisposition.slice(contentDisposition.indexOf("''")).replace("''", "");
    const path = document.createElement('a');
    path.href = URL.createObjectURL(file);
    path.download = filename;
    path.click();
}